<script>
import FormWrapper from "@/components/ui/forms/FormWrapper.vue";
import FormControl from "@/components/ui/forms/FormControl.vue";
import FormLabel from "@/components/ui/forms/FormLabel.vue";
import FormElement from "@/components/ui/forms/FormElement.vue";
import Button2 from "@/components/ui/Button2.vue";
import UiSelect from "@/components/ui/forms/Select.vue";
import InputPhone from "@/components/ui/forms/InputPhone.vue";
import ChannelIcon from "./ChannelIcon.vue";
import ChannelValidation from "./ChannelValidation.vue";
import { CHANNEL_TYPE } from "./enum-channel-type"
import InputEmail from "@/components/ui/forms/InputEmail.vue";

export default {
  name: "ChannelForm",
  components: {
    Button2,
    FormControl,
    FormElement,
    FormLabel,
    FormWrapper,
    InputPhone,
    UiSelect,
    ChannelIcon,
    ChannelValidation,
    InputEmail,
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    showValidation: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isNewChannel() {
      return !this.value.id;
    },
  },
  data() {
    return {
      CHANNEL_TYPE,
      channel: {
        ...this.value,
        type: this.value.type || CHANNEL_TYPE.DEFAULT,
        value: this.value.value || "",
        validated: this.value.validated || false,
        value_number: this.value.type !== CHANNEL_TYPE.EMAIL ? this.value.value : '',
        value_email: this.value.type === CHANNEL_TYPE.EMAIL ? this.value.value : '',
      },
    };
  },
  watch: {
    channel: {
      handler(newValue) {
        if (newValue.type === CHANNEL_TYPE.EMAIL) {
          newValue.value = newValue.value_email
        } else {
          newValue.value = newValue.value_number
        }
        this.$emit('input', newValue)
      },
      deep: true
    }
  }
};
</script>

<template>
  <FormWrapper>
    <FormControl>
      <FormLabel>{{ $t("watchmen.channels.type.label") }}</FormLabel>
      <FormElement class="position-relative w-100">
        <UiSelect 
          v-model="channel.type" 
          :disabled="!isNewChannel && channel.type === CHANNEL_TYPE.EMAIL"
          class="select-type"
        >
          <option value="" disabled>{{ $t("watchmen.channels.type.select_placeholder") }}</option>
          <option :value="CHANNEL_TYPE.MOBILE">{{ $t("watchmen.channels.type.mobile") }}</option>
          <option :value="CHANNEL_TYPE.PHONE">{{ $t("watchmen.channels.type.phone") }}</option>
          <option :value="CHANNEL_TYPE.EMAIL" :disabled="!isNewChannel && channel.type !== CHANNEL_TYPE.EMAIL">
            {{ $t("watchmen.channels.type.email") }}
          </option>
        </UiSelect>
        <ChannelIcon :type="channel.type" class="select-type-icon" />
      </FormElement>
    </FormControl>
    <FormControl v-if="channel.type === CHANNEL_TYPE.EMAIL">
      <FormLabel>{{ $t("watchmen.channels.value_email") }}</FormLabel>
      <InputEmail v-model="channel.value_email" placeholder="example@domain.com" />
    </FormControl>
    <FormControl v-else>
      <FormLabel>{{ $t("watchmen.channels.value_number") }}</FormLabel>
      <InputPhone v-model="channel.value_number" />
    </FormControl>
    <FormControl v-if="showValidation && channel.type !== CHANNEL_TYPE.EMAIL">
      <FormLabel>{{ $t("watchmen.channels.validation") }}</FormLabel>
      <FormElement>
        <ChannelValidation :channel="channel" />
      </FormElement>
    </FormControl>
  </FormWrapper>
</template>

<style lang="scss" scoped>
  .select-type {
    padding-left: 2.5rem;
  }
  .select-type-icon {
    font-size: 16px;
    position: absolute;
    top: 0.5rem;
    left: 1rem;
    pointer-events: none;
    color: var(--colors-gray-400);
  }
</style>
